import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Card from 'components/Card/Card';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import CardBody from 'components/Card/CardBody';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { Button as ButtonPrime } from 'primereact/button';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { FaSpinner } from 'react-icons/fa';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/anotacao.css';

class Anotacao extends Component {
  state = {
    anotacao: null,
    anotacoes: [],
    mostrarMeusPedidos: false,
    mostrarAreaTecnica: false,
    globalFilter: null,
    first: 0,
    loading: false,
    loadingGravar: false,
    abreExcluirAnotacao: false,
    idAnotacao: null,
    selectedDateInclusao: null,
  };

  listarAnotacoes = () => {
    this.setState({ loading: true });
    dominioDemandaCirurgica.get(`/api/anotacao/${this.props.pedidoCirurgia}`).then(response => {
      this.setState({
        anotacoes: response.data,
        loading: false,
      });
    });
  };

  componentDidMount() {
    this.listarAnotacoes();
  }

  anotacaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Anotação</span>
        <span>
          <p>{rowData.anotacao}</p>
        </span>
      </>
    );
  };

  dataBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data</span>
        <span>{new Date(rowData.dataInclusao).toLocaleString()}</span>
      </>
    );
  };

  paraMedicoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Para Médico</span>
        <span>
          <Checkbox checked={rowData.mostraMeusPedidos} color="primary" />
        </span>
      </>
    );
  };

  paraAreaTecnicaBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Para Área Técnica</span>
        <span>
          <Checkbox checked={rowData.mostraAreaTecnica} color="primary" />
        </span>
      </>
    );
  };

  renderFooterDisplay = () => {
    return (
      <div>
        <ButtonPrime
          label="Não"
          icon="pi pi-times"
          onClick={() => this.setState({ abreExcluirAnotacao: false })}
          className="p-button-text"
        />
        <ButtonPrime
          label="Sim"
          icon="pi pi-check"
          onClick={() => this.handleExcluirAnotacao(this.state.idAnotacao)}
          autoFocus
        />
      </div>
    );
  };

  acoesBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Ações</span>
        <span>
          <IconButton
            aria-label="delete"
            onClick={() => this.setState({ abreExcluirAnotacao: true, idAnotacao: rowData.id })}
          >
            <DeleteIcon />
          </IconButton>
        </span>
      </>
    );
  };

  handleExcluirAnotacao = id => {
    dominioDemandaCirurgica.delete(`/api/anotacaodetail/${id}`).then(() => {
      this.setState({
        idAnotacao: null,
        abreExcluirAnotacao: false,
      });
      this.listarAnotacoes();
    });
  };

  handleGravarAnotacao = event => {
    event.preventDefault();

    const data = {
      anotacao: this.state.anotacao,
      mostraMeusPedidos: this.state.mostrarMeusPedidos,
      mostraAreaTecnica: this.state.mostrarAreaTecnica,
      pedidoCirurgia: this.props.pedidoCirurgia,
    };

    this.setState({ loadingGravar: true });

    dominioDemandaCirurgica.post(`/api/anotacao`, data).then(() => {
      this.setState({
        anotacao: null,
        mostrarMeusPedidos: false,
        mostrarAreaTecnica: false,
        loadingGravar: false,
      });
      document.getElementById('anotacao').value = null;
      this.listarAnotacoes();
    });
  };

  render() {
    const header = (
      <>
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '50vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    const pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm',
    };

    const dateInclusaoFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateInclusao}
        onChange={e => {
          this.setState({ selectedDateInclusao: e.value });
          if (e.value === null) {
            this.dt.filter(null, 'dataInclusao', 'notEquals');
            return;
          }
          this.dt.filter(
            new Date(e.value).toISOString().substring(0, 10),
            'dataInclusao',
            'startsWith'
          );
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const renderNovaAnotacao = () => {
      if (!this.props.profissionalObservador)
        return (
          <form onSubmit={this.handleGravarAnotacao}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  style={{ marginTop: '10px' }}
                  multiline
                  required
                  rows={5}
                  rowsMax={5}
                  name="anotacao"
                  variant="outlined"
                  fullWidth
                  id="anotacao"
                  value={this.state.anotacao}
                  onChange={e => this.setState({ anotacao: e.target.value })}
                  inputProps={{
                    maxLength: 300,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className="grid-align-right">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.mostrarMeusPedidos}
                        onChange={e => this.setState({ mostrarMeusPedidos: e.target.checked })}
                        name="mostrarMeusPedidos"
                        color="primary"
                      />
                    }
                    label="Mostrar para o Médico"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.mostrarAreaTecnica}
                        onChange={e => this.setState({ mostrarAreaTecnica: e.target.checked })}
                        name="mostrarAreaTecnica"
                        color="primary"
                      />
                    }
                    label="Mostrar para o Área Técnica"
                  />
                  <Button type="submit" variant="contained" color="primary">
                    {this.state.loadingGravar ? (
                      <FaSpinner size={20} className="loading" />
                    ) : (
                      <>Gravar</>
                    )}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        );
      return null;
    };

    return (
      <>
        <DialogPrime
          header="Excluir anotação"
          visible={this.state.abreExcluirAnotacao}
          style={{ width: '65vw' }}
          footer={this.renderFooterDisplay()}
          onHide={() => this.setState({ abreExcluirAnotacao: false })}
        >
          <p>Deseja realmente excluir?</p>
        </DialogPrime>
        {renderNovaAnotacao()}
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <Card>
              <CardBody className="card-body-0-padding">
                <div className="datatable">
                  <div className="card" id="tableAnotacao">
                    <DataTable
                      ref={el => (this.dt = el)}
                      value={this.state.anotacoes}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={5}
                      className="p-datatable-prime"
                      emptyMessage="Sem anotações"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href.replace(
                          '#centroAnotacoes',
                          ''
                        )}#centroAnotacoes`;
                      }}
                      id="centroAnotacoes"
                    >
                      <Column
                        field="anotacao"
                        header="Anotação"
                        sortable
                        body={this.anotacaoBodyTemplate}
                        filter
                        filterPlaceholder="Anotação"
                        filterMatchMode="contains"
                        headerStyle={{ width: '25vw' }}
                      />
                      <Column
                        field="dataInclusao"
                        header="Data"
                        sortable
                        body={this.dataBodyTemplate}
                        filter
                        filterElement={dateInclusaoFilter}
                        filterFunction={() => this.filterDate()}
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="mostraMeusPedidos"
                        header="Para médico"
                        sortable
                        body={this.paraMedicoBodyTemplate}
                      />
                      <Column
                        field="mostraAreaTecnica"
                        header="Para Área Técnica"
                        sortable
                        body={this.paraAreaTecnicaBodyTemplate}
                      />
                      <Column header="Ações" body={this.acoesBodyTemplate} />
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </>
    );
  }
}

export default Anotacao;
